import { adminCopy } from '@/copy'
import { Select } from '@/ui/Field/Field'
import type { WorkspaceInfo } from '../types/api'
import styles from './WorkspacePicker.module.css'

interface Props {
  workspaces: WorkspaceInfo[]
  value: string
  onChange: (workspaceId: string) => void
}

/** Admin-scoped workspace selector, shared by any panel that can show data for any workspace. */
export function WorkspacePicker({ workspaces, value, onChange }: Props) {
  return (
    // D223: the label is visually hidden (D8); the selected workspace is the
    // visible hint.
    <div className={styles.picker}>
      <Select
        aria-label={adminCopy.workspacePicker.label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {workspaces.length === 0 && (
          <option value="">{adminCopy.workspacePicker.empty}</option>
        )}
        {workspaces.map((o) => (
          <option key={o.workspace_id} value={o.workspace_id}>
            {o.name}
          </option>
        ))}
      </Select>
    </div>
  )
}
